/* eslint-disable max-len */
/**
 * @file 投放路由
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

import perms from '@/common/permissions/sale/perms';
import { ACCOUNT_TYPE, AD_PLATFORM_TYPE_NAME } from '@/constants/Constants';

import { oneOf } from './utils';

export default [
  {
    label: '投放',
    key: 'advertising',
    disabled: (loginStatus: any) => loginStatus.onlyTechAgency,
    // desc: '查看广告主列表和投放数据；支持免登录投放端；创建ADQ/MP子客账户',
    breathingLight: (account: any) => {
      return account.navBreathingLight?.passiveAccumulation;
    },
    data: [
      {
        label: '客户',
        key: 'account',
        iconClassName: 'icon-nav-customer',
        data: [
          {
            label: '账户列表',
            href: '/agency/advertiser-list/tencent',
            path: '/agency/advertiser-list/:type',
            key: 'account_list',
            purview: 2010,
            data: [
              {
                id: 'advertising',
                href: '/agency/advertiser-list/tencent',
                label: 'ADQ营销',
                platform: AD_PLATFORM_TYPE_NAME.ADQ,
                purview: 11,
                pagePurview: {
                  addPerm: 12,
                  downloadPerm: 15,
                  fastAddAccountRecordPrem: 22008,
                },
                perm: (loginStatus: Record<string, any>) => {
                  return !loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency;
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-list/tencent/Layout'), { fallback: <Loading /> }),
                behavior: {
                  addAccount: '新增账户',
                  editOperator: '“运营人员”列小画笔',
                  editDesigner: '“设计师”列小画笔',
                  editSelfOperator: '“自理投放管理员”列小画笔',
                  advertise: '投放平台',
                  tacc: '创意中心',
                  collect: '收藏',
                  batchCollect: '批量收藏',
                  assignment: '分配设计师',
                  accountFile: '账户档案',
                },
                basePage: true,
              },
              // 新版 ———— 支持全部服务商
              {
                id: 'advertising',
                href: '/agency/advertiser-list/tencent',
                label: 'ADQ营销',
                platform: AD_PLATFORM_TYPE_NAME.ADQ,
                purview: 11,
                pagePurview: {
                  addPerm: 12,
                  downloadPerm: 15,
                  fastAddAccountRecordPrem: 22008,
                },
                perm: (loginStatus: Record<string, any>) => {
                  return loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency;
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-list/tencent/new_Layout'), { fallback: <Loading /> }),
                behavior: {
                  addAccount: '新增账户',
                  editOperator: '“运营人员”列小画笔',
                  editDesigner: '“设计师”列小画笔',
                  editSelfOperator: '“自理投放管理员”列小画笔',
                  advertise: '投放平台',
                  tacc: '创意中心',
                  collect: '收藏',
                  batchCollect: '批量收藏',
                  assignment: '分配设计师',
                  accountFile: '账户档案',
                },
                basePage: true,
              },
              // 授权开户
              {
                label: '授权开户记录',
                href: '/agency/advertiser-list/auth-list',
                purview: 2001,
                hide: true,
                perm: (loginStatus: Record<string, any>) => !loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency && loginStatus.account_type !== ACCOUNT_TYPE.direct,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-auth/list/index'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
              {
                label: '授权开户记录',
                href: '/agency/advertiser-list/auth-list',
                purview: 2001,
                hide: true,
                perm: (loginStatus: Record<string, any>) => loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency && loginStatus.account_type !== ACCOUNT_TYPE.direct,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-auth/list/new_list'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
              {
                id: 'wechatlist',
                href: '/agency/advertiser-list/wechat',
                label: 'WX旧营销',
                tip: '原MP营销',
                platform: AD_PLATFORM_TYPE_NAME.MP,
                purview: 19,
                enableKey: 'is_wechat_advertiser_enable',
                pagePurview: {
                  downloadPerm: 2003,
                  editPerm: 2002,
                  addPerm: 2001,
                  showWechatSummaryPerm: 2012,
                  showWechatLogPerm: 2007,
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-list/wechat/Layout'), { fallback: <Loading /> }),
                behavior: {
                  addAccount: '新增账户',
                  editOperator: '“运营人员”列小画笔',
                  advertise: '投放平台',
                  bindRecord: '绑定记录',
                  collect: '收藏',
                  batchCollect: '批量收藏',
                },
                basePage: true,
              },
              {
                id: 'cpslist',
                href: '/agency/advertiser-list/cps',
                label: 'CPS商品营销',
                platform: AD_PLATFORM_TYPE_NAME.CPS,
                purview: 11,
                enableKey: 'is_cps_agency_enable',
                perm: (loginStatus: Record<string, any>) => {
                  return !loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency;
                },
                pagePurview: {
                  fastAddAccountRecordPrem: 22008,
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-list/cps/Layout'), { fallback: <Loading /> }),
                behavior: {
                  addAccount: '新增帐号',
                  editOperator: '“运营人员”列小画笔',
                  advertise: '投放平台',
                  bindRecord: '绑定记录',
                },
                basePage: true,
              },
              {
                id: 'cpslist',
                href: '/agency/advertiser-list/cps',
                label: 'CPS商品营销',
                platform: AD_PLATFORM_TYPE_NAME.CPS,
                purview: 11,
                enableKey: 'is_cps_agency_enable',
                perm: (loginStatus: Record<string, any>) => {
                  return !!loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency;
                },
                pagePurview: {
                  fastAddAccountRecordPrem: 22008,
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-list/cps/new_Layout'), { fallback: <Loading /> }),
                behavior: {
                  addAccount: '新增帐号',
                  editOperator: '“运营人员”列小画笔',
                  advertise: '投放平台',
                  bindRecord: '绑定记录',
                },
                basePage: true,
              },
              {
                label: '身份验证',
                href: '/agency/account/payment-certification',
                purview: 9278325,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/paymentCertification/account-entry'), { fallback: <Loading /> }),
                singleTabNav: true,
                basePage: true,
                hide: true,
                showSideNav: false,
              },
              {
                id: 'wechatlog',
                label: 'WX旧营销绑定记录',
                href: '/agency/account/wechatlog/index',
                hide: true,
                platform: AD_PLATFORM_TYPE_NAME.MP,
                purview: 2007,
                pagePurview: {
                  downloadPerm: 2003,
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/wechatlog/Layout'), { fallback: <Loading /> }),
                hideTabNav: true,
              },
              {
                id: 'unauthorized_account',
                label: 'WX旧营销未授权账户',
                href: '/agency/account/unauthorized',
                hide: true,
                platform: AD_PLATFORM_TYPE_NAME.MP,
                purview: 19,
                pagePurview: {
                  downloadPerm: 2003,
                  editPerm: 2002,
                  addPerm: 2001,
                  showWechatSummaryPerm: 2012,
                  showWechatLogPerm: 2007,
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-list/wechat/unauthorized'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
              },
              {
                id: 'account_detail',
                label: '账户详情',
                href: '/agency/account/detail',
                hide: true,
                purview: 11,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/detail'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
              {
                id: 'account_private_domain',
                label: '备案企业工具号',
                href: '/agency/account/private-domain',
                purview: 203,
                hide: true,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/private-domain/Layout'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
              {
                id: 'fastAddAccount',
                label: '极速开户历史',
                href: '/agency/account/fast-copy-history',
                hide: true,
                platform: [AD_PLATFORM_TYPE_NAME.ADQ, AD_PLATFORM_TYPE_NAME.CPS],
                perm: (loginStatus: Record<string, any>) => {
                  return !loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency;
                },
                purview: 22008,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/fast-copy-history/Layout'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
              {
                id: 'fastAddAccount',
                label: '极速开户历史',
                href: '/agency/account/fast-copy-history',
                hide: true,
                platform: [AD_PLATFORM_TYPE_NAME.ADQ, AD_PLATFORM_TYPE_NAME.CPS],
                perm: (loginStatus: Record<string, any>) => {
                  return !!loginStatus?.feature_flag?.is_enable_advertiser_list_support_multiple_agency;
                },
                purview: 22008,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/fast-copy-history/new_Layout'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
              {
                id: 'complaint_list',
                label: '投诉单据',
                href: '/agency/complaint/list',
                hide: true,
                purview: 97,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/complaint'), { fallback: <Loading /> }),
                basePage: true,
                hideTabNav: true,
                hideSubNav: true,
              },
            ],
          },
          {
            label: '投放平台',
            href: '/agency/advertising/tencent',
            path: '/agency/advertising/:type',
            key: 'account_rpt',
            purview: 2011,
            data: [
              {
                id: 'accountlist',
                href: '/agency/advertising/tencent',
                label: 'ADQ营销',
                platform: AD_PLATFORM_TYPE_NAME.ADQ,
                purview: 16,
                disabled: (loginStatus: Record<string, any>) => loginStatus.feature_flag.is_enable_delivery_rpt_support_multiple_agency,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertising/tencent/Layout'), { fallback: <Loading /> }),
                behavior: {
                  advertise: '投放平台',
                  tacc: '创意中心',
                  collect: '收藏',
                  batchCollect: '批量收藏',
                  hourlyReport: '小时数据',
                },
                basePage: true,
              },
              {
                id: 'accountlist',
                href: '/agency/advertising/tencent',
                label: 'ADQ营销',
                platform: AD_PLATFORM_TYPE_NAME.ADQ,
                purview: 16,
                enableKey: 'is_enable_delivery_rpt_support_multiple_agency',
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertising/tencent/index'), { fallback: <Loading /> }),
                basePage: true,
              },
              {
                id: 'wechatrpt',
                href: '/agency/advertising/wechat',
                label: 'WX旧营销',
                tip: '原MP营销',
                platform: AD_PLATFORM_TYPE_NAME.MP,
                purview: 2004,
                enableKey: 'is_wechat_advertiser_enable',
                pagePurview: {
                  downloadPerm: 2006,
                },
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertising/wechatrpt/Layout'), { fallback: <Loading /> }),
                behavior: {
                  advertise: '投放平台',
                  collect: '收藏',
                  batchCollect: '批量收藏',
                },
                basePage: true,
              },
            ],
          },
          {
            label: '开户单',
            href: '/registration/register',
            path: '/registration/:type',
            key: 'registration-register-manage',
            data: [{
              label: '开户单',
              href: '/registration/register',
              key: 'registration-register',
              perm: oneOf([perms.OPS_REGISTRATION_TICKET_REGISTER, perms.OPS_REGISTRATION_TICKET_VIEW_SELF]),
              component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/register/AccountRegisterList'), { fallback: <Loading /> }),
              basePage: true,
            },
            {
              label: '分配开户人',
              href: '/registration/assign',
              key: 'registration-assign',
              perm: oneOf([perms.OPS_REGISTRATION_TICKET_ASSIGN_REVIEW]),
              component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/register/AccountAssignList'), { fallback: <Loading /> }),
              basePage: true,
            }],
          },
          {
            label: '账户分组',
            href: '/agency/advertiser-group',
            key: 'account_group',
            purview: 88,
            disabled: (loginStatus: Record<string, any>) => !loginStatus.bm_id, // 单体服务商暂无账户分组权限
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/advertiser-group'), { fallback: <Loading /> }),
            basePage: true,
            singleTabNav: true,
          },
          {
            label: '推广',
            key: 'ad-manage-all',
            href: '/agency/ad-manage/new',
            path: '/agency/ad-manage/:type',
            data: [{
              label: '3.0',
              href: '/agency/ad-manage/new',
              key: 'new-ad-manage',
              purview: 95,
              component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/admanage/new'), { fallback: <Loading /> }),
              basePage: true,
              isNew: true,
            }, {
              label: '2.0',
              href: '/agency/ad-manage/old',
              key: 'ad-manage',
              purview: 95,
              component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/admanage'), { fallback: <Loading /> }),
              basePage: true,
            }],
          },
          {
            key: 'work-order',
            href: '/agency/work-order',
            label: '城市攻坚工单',
            basePage: true,
            perm: (loginStatus: Record<string, any>) => {
              // return true;
              // 包含灰度权限码，展示城市攻坚工单列表入口
              return _.includes(loginStatus.saleStatus?.grayPermissions, perms.GRAY_HHR_ORDER);
            },
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/workOrder'), {
              fallback: <Loading />,
            }),
            singleTabNav: true,
          },
          {
            label: 'adq帐号档案',
            href: '/agency/accountFileAdq',
            hide: true,
            purview: 201,
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/component/accountFile'), { fallback: <Loading /> }),
            hideSubNav: true,
            hideTabNav: true,
          },
          {
            label: 'mp帐号档案',
            href: '/agency/accountFileMp',
            hide: true,
            purview: 202,
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/component/accountFile'), { fallback: <Loading /> }),
            hideSubNav: true,
            hideTabNav: true,
          },
          {
            id: 'addAccount',
            key: 'addAccount',
            hide: true,
            href: '/agency/advertiser-add-account/:param?',
            label: 'ADQ营销新增帐号',
            // purview: 12, // 需要灰度控制使用不同的权限码，改为页面内部做权限控制
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/account/component/NewAddAccount/Layout'), { fallback: <Loading /> }),
          },
          {
            id: 'am-add-account',
            key: 'am-add-account',
            hide: true,
            href: '/agency/advertiser-add-account-am/:param?',
            label: 'ADQ营销新增帐号',
            isMicroApp: true,
          },
        ],
      },
      {
        label: '报表',
        key: 'report',
        desc: '查看服务商、客户、帐号维度数据',
        enableKey: 'is_rpt_enable',
        iconClassName: 'icon-nav-report',
        data: [
          {
            label: '服务商维度',
            href: '/agency/report-agent/basic',
            path: '/agency/report-agent/:type',
            key: 'report-agency',
            purview: 9,
            data: [
              {
                id: 'basic',
                href: '/agency/report-agent/basic',
                label: '基础报表',
                purview: 84,
                basePage: true,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/basic/layout'), { fallback: <Loading /> }),
                behavior: {
                  dateRange: '日期范围',
                  customColumns: '自定义列',
                },
              },
            ],
          },
          {
            key: 'report-customer',
            label: '客户维度',
            href: '/agency/report-customer',
            purview: 80,
            data: [{
              key: 'reportcustomer-basic',
              label: '客户维度报表',
              href: '/agency/report-customer',
              purview: 80,
              pagePurview: {
                downloadPerm: 81,
              },
              basePage: true,
              component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/customer/Layout'), { fallback: <Loading /> }),
              behavior: {
                realtimeQuery: '实时查询',
              },
            }],
          },
          {
            label: '账户维度',
            href: '/agency/report-advertise/detail',
            path: '/agency/report-advertise/:type',
            key: 'report-advertise',
            purview: 8,
            data: [
              {
                id: 'advertise-detail',
                href: '/agency/report-advertise/detail',
                label: '明细报表',
                basePage: true,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/advertise/Layout'), { fallback: <Loading /> }),
                purview: 86,
                behavior: {
                  realtimeQuery: '实时查询',
                },
              },
              {
                id: 'advertise-basic',
                href: '/agency/report-advertise/basic',
                label: '基础报表',
                purview: 2,
                basePage: true,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/advertise/PreLayout'), { fallback: <Loading /> }),
                behavior: {
                  realtimeQuery: '实时查询',
                },
              },
            ],
          },
          {
            key: 'report-adrpt',
            href: '/agency/report-adrpt',
            label: '营销单元维度',
            purview: 82,
            data: [{
              key: 'adrpt-basic',
              href: '/agency/report-adrpt',
              label: '营销单元维度报表',
              purview: 82,
              basePage: true,
              component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/ad/Layout'), { fallback: <Loading /> }),
            }],
          },
          {
            label: '消耗报表',
            href: '/agency/report-finance/agency',
            path: '/agency/report-finance/:type',
            key: 'report-finance',
            disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            data: [
              {
                id: 'report-finance-agency',
                href: '/agency/report-finance/agency',
                label: '服务商维度',
                purview: 9,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/finance/agency'), { fallback: <Loading /> }),
                basePage: true,
              },
              {
                id: 'report-finance-advertiser',
                href: '/agency/report-finance/advertiser',
                className: '',
                label: '账户维度',
                purview: 8,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/finance/advertiser'), { fallback: <Loading /> }),
                basePage: true,
              },
              {
                id: 'report-finance-compaign',
                href: '/agency/report-finance/compaign',
                label: '计划维度',
                purview: 82,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/finance/compaign'), { fallback: <Loading /> }),
                basePage: true,
              },
              {
                id: 'report-finance-ad',
                href: '/agency/report-finance/adrpt',
                label: '营销单元维度',
                purview: 82,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/finance/ad'), { fallback: <Loading /> }),
                basePage: true,
              },
            ],
          },
          {
            label: '跨账户分析',
            key: 'report-worktable-all',
            href: '/agency/report-worktable/new',
            path: '/agency/report-worktable/:type',
            data: [
              {
                label: '3.0',
                href: '/agency/report-worktable/new',
                key: 'new-report-worktable',
                purview: 89,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/worktable/new'), { fallback: <Loading /> }),
                basePage: true,
                isNew: true,
              },
              {
                label: '2.0',
                href: '/agency/report-worktable/old',
                key: 'report-worktable',
                purview: 89,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/worktable'), { fallback: <Loading /> }),
                basePage: true,
              },
            ],
          },
          {
            label: '商品分析',
            href: '/agency/report-categogy/advertiser',
            path: '/agency/report-categogy/advertiser',
            key: 'report-categogy-all',
            data: [
              {
                id: 'report-categogy-advertiser',
                href: '/agency/report-categogy/advertiser',
                className: '',
                label: '账户维度',
                purview: 140,
                enableKey: 'is_enable_product_category_rpt',
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/product-category'), { fallback: <Loading /> }),
                basePage: true,
              },
            ],
          },
          {
            label: '日报&时报',
            href: '/agency/report-daily/list',
            path: '/agency/report-daily/:type',
            key: 'report-daily',
            data: [
              {
                id: 'report-daily-list',
                href: '/agency/report-daily/list',
                className: '',
                label: '日报&时报',
                purview: 1111,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/daily-report/list'), { fallback: <Loading /> }),
                basePage: true,
              },
              {
                id: 'report-daily-create',
                href: '/agency/report-daily/(create|edit|view)/:id?',
                className: '',
                label: '新建日报&时报',
                purview: 1111,
                hide: true,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/daily-report/create'), { fallback: <Loading /> }),
                basePage: true,
              },
            ],
          },
          {
            label: '厂店通罗盘',
            key: 'channels-compass',
            // isExternal: 标记为站外独立系统，侧边栏点击时走原生 window.open，
            // 不经 react-router，避免绝对地址被拼上 basename /ams
            isExternal: true,
            // 站外独立系统，需用绝对地址跳到 e.qq.com/tybp/（不带 basename /ams）
            href: () => `${window.location.origin}/tybp/`,
            target: '_blank',
            rel: 'opener',
            data: [],
            enableKey: 'is_tengyi_dashboard',
          },
          {
            label: '搜狗历史数据',
            href: '/agency/report-sogou/history',
            path: '/agency/report-sogou/:type',
            key: 'report-sogou',
            enableKey: 'is_show_sogou_report',
            purview: 98,
            data: [
              {
                id: 'report-sogou-history',
                href: '/agency/report-sogou/history',
                label: '搜狗历史数据',
                purview: 98,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/sogou/history'), { fallback: <Loading /> }),
                basePage: true,
              },
              {
                id: 'report-sogou-backup',
                href: '/agency/report-sogou/backup',
                label: '搜狗系统备份数据',
                purview: 98,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/sogou/backup'), { fallback: <Loading /> }),
                basePage: true,
              },
            ],
          },
          {
            label: '腾盟魔方',
            href: '/agency/report-portrait/tag-utilize/customer',
            path: '/agency/report-portrait/tag-utilize/:type',
            key: 'report-portrait',
            purview: 92,
            enableKey: 'is_agency_dashboard_enable',
            data: [
              {
                label: '标签应用',
                href: '/agency/report-portrait/tag-utilize/customer',
                path: '/agency/report-portrait/tag-utilize/:type',
                purview: 92,
                hide: true,
                data: [
                  {
                    label: '客户维度',
                    href: '/agency/report-portrait/tag-utilize/customer',
                    purview: 92,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/portrait/tag-customer'), { fallback: <Loading /> }),
                    basePage: true,
                    hideTabNav: true,
                  },
                  {
                    label: '账户维度',
                    href: '/agency/report-portrait/tag-utilize/advertiser',
                    purview: 92,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/portrait/tag-advertiser'), { fallback: <Loading /> }),
                    basePage: true,
                    hideTabNav: true,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        label: '政策看板',
        key: 'policy-dashboard',
        iconClassName: 'icon-nav-performance',
        data: [
          {
            id: 'report-categogy-overview',
            href: '/agency/report-categogy/overview',
            label: '政策全景看板',
            component: loadable(() => import(/* webpackChunkName: 'manage' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/category-overview'), { fallback: <Loading /> }),
            basePage: true,
            perm: (loginStatus: Record<string, any>) => {
              return _.includes(loginStatus.privilege, 370);
            },
            singleTabNav: true,
          },
          {
            id: 'report-passive-accumulation',
            breathingLight: (account: any) => {
              return account.navBreathingLight?.passiveAccumulation;
            },
            label: '被动累量看板',
            href: '/agency/passive-accumulation',
            component: loadable(() => import(/* webpackChunkName: 'manage' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/passive-accumulation'), { fallback: <Loading /> }),
            perm: (loginStatus: Record<string, any>) => loginStatus.dynamicNavAuth?.passiveAccEnable !== false,
            purview: 371,
            enableKey: 'is_enable_accumulation_report',
            basePage: true,
            singleTabNav: true,
          },
          // {
          //   label: '腰客看板',
          //   href: '/agency/city-crucial/waist-guest',
          //   path: '/agency/city-crucial/:type',
          //   key: 'city-crucial-databoard',
          //   perm: (loginStatus: Record<string, any>) => {
          //     // isInMidCustWhiteList 白名单
          //     // agencyZCGroupId 政策集团 id
          //     return !!loginStatus.saleStatus?.agencyZCGroupId;
          //   },
          //   data: [
          //     {
          //       label: '腰客看板',
          //       href: '/agency/city-crucial/waist-guest',
          //       component: loadable(() => import(/* webpackChunkName: 'manage' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/waistguestdataboard'), { fallback: <Loading /> }),
          //       basePage: true,
          //       perm: (loginStatus: Record<string, any>) => {
          //         return !!loginStatus.saleStatus?.isInMidCustWhiteList && !!loginStatus.saleStatus?.agencyZCGroupId;
          //       },
          //     },
          //     {
          //       href: '/agency/city-crucial/detail',
          //       label: '客户明细',
          //       basePage: true,
          //       component: loadable(() => import(/* webpackChunkName: 'manage' */ /* webpackMode: 'lazy' */ '@/pages/agency/report/hhrDetail'), { fallback: <Loading /> }),
          //     },
          //   ],
          // },
        ],
      },
      {
        label: '资产',
        key: 'assets_manage',
        iconClassName: 'icon-nav-assets',
        data: [
          {
            // 复用顶部 Creative+ 入口，点击时新增 page=IMAGE 参数跳转图片管理
            label: '创意资产管理',
            key: 'creative-assets-agency',
            href: '/creative-assets?page=IMAGE',
            path: '/creative-assets',
            // href 借用了顶级 Creative+ 的路径，导航归属判断时需排除，避免顶级「Creative+」和「投放」同时高亮
            hideFromNavLink: true,
            component: loadable(() => import(/* webpackChunkName: 'creative-assets' */ /* webpackMode: 'lazy' */ '@/pages/creative-assets'), { fallback: <Loading /> }),
            basePage: true,
            showSideNav: false,
            hideTabNav: true,
            enableKey: 'is_bm_component_manage_enable',
          },
          {
            label: '创意组件预审',
            key: 'creative-component-preview',
            href: '/agency/preview-component/preview-agency',
            enableKey: 'is_bm_component_preaudit_enable',
            data: [
              {
                label: '组件预审列表',
                key: 'preview_list',
                href: '/agency/preview-component/preview-agency',
                path: '/agency/preview-component/preview-:type',
                data: [
                  {
                    id: 'preview-agency',
                    label: '服务商业务单元',
                    href: '/agency/preview-component/preview-agency',
                    purview: 132,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/preview-list/preview-agency'), { fallback: <Loading /> }),
                    basePage: true,
                  },
                  // {
                  //   id: 'preview-custom',
                  //   label: '客户业务单元',
                  //   href: '/agency/preview-component/preview-custom',
                  // purview: 132,
                  //   component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/preview-list/preview-custom'), { fallback: <Loading /> }),
                  //   basePage: true,
                  // },
                  {
                    id: 'preview-advertiser',
                    label: '客户主体',
                    href: '/agency/preview-component/preview-advertiser',
                    purview: 132,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/preview-list/preview-advertiser'), { fallback: <Loading /> }),
                    basePage: true,
                  },
                ],
              },
              {
                label: '预审开关配置',
                key: 'creative-preview-switch',
                href: '/agency/preview-component/switch-all',
                path: '/agency/preview-component/switch-:type',
                data: [
                  {
                    id: 'switch-all',
                    label: '全局默认配置',
                    href: '/agency/preview-component/switch-all',
                    purview: 132,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/switch/switch-all'), { fallback: <Loading /> }),
                    basePage: true,
                  },
                  {
                    id: 'switch-agency',
                    label: '服务商业务单元',
                    href: '/agency/preview-component/switch-agency',
                    purview: 132,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/switch/switch-agency'), { fallback: <Loading /> }),
                    basePage: true,
                  },
                  // {
                  //   id: 'switch-custom',
                  //   label: '客户业务单元',
                  //   href: '/agency/preview-component/switch-custom',
                  // purview: 132,
                  //   component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/switch/switch-custom'), { fallback: <Loading /> }),
                  //   basePage: true,
                  // },
                  {
                    id: 'switch-advertiser',
                    label: '客户主体',
                    href: '/agency/preview-component/switch-advertiser',
                    purview: 132,
                    component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/creative-component/switch/switch-advertiser'), { fallback: <Loading /> }),
                    basePage: true,
                  },
                ],
              },
              {
                id: 'creative_audit_secret',
                label: '三方账号配置',
                href: '/agency/preview-component/audit-secret',
                purview: 132,
                component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/assets/creative-material/manage/audit-secret'), { fallback: <Loading /> }),
                basePage: true,
                singleTabNav: true,
              },
            ],
          },
          {
            label: '推广内容资产',
            path: '/agency/assets/ad-content/:type',
            href: '/agency/assets/ad-content/common',
            key: 'assets_ad_content',
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/assets/ad-content/index'), { fallback: <Loading /> }),
            basePage: true,
          },
          {
            label: '资产授权',
            href: '/agency/assets/auth',
            path: '/agency/assets/(auth|auth/list)',
            key: 'assets_list',
            className: 'menu-nav-sub-arrow',
            perm: (loginStatus: Record<string, any>) => {
              const {
                bm_id,
                saleStatus = {},
              } = loginStatus;
              const {
                assetBmIdsWhiteList = [],
              } = saleStatus;
              if (!assetBmIdsWhiteList || assetBmIdsWhiteList.length === 0) {
                return true;
              }
              return oneOf([perms.PERM_ASSEST_ENTRY]) && _.includes(assetBmIdsWhiteList, bm_id);
            },
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/assets/authorize/pages/list'), { fallback: <Loading /> }),
            basePage: true,
          },
          {
            label: '资产授权',
            href: '/agency/assets/auth/list',
            key: 'assets_auth',
            perm: (loginStatus: Record<string, any>) => {
              const {
                bm_id,
                saleStatus = {},
              } = loginStatus;
              const {
                assetBmIdsWhiteList = [],
              } = saleStatus;
              if (!assetBmIdsWhiteList || assetBmIdsWhiteList.length === 0) {
                return true;
              }
              return oneOf([perms.PERM_ASSEST_ENTRY]) && _.includes(assetBmIdsWhiteList, bm_id);
            },
            component: loadable(() => import(/* webpackChunkName: 'advertising' */ /* webpackMode: 'lazy' */ '@/pages/agency/assets/authorize/pages/assetsAuthList'), { fallback: <Loading /> }),
            basePage: true,
            hide: true,
          },
        ],
      },
    ],
  },
];
